import React from 'react';

import { ThemeProvider } from 'emotion-theming';

export default function generateTintTheme(color) {
  const Theme = ({ children }) => (
    <ThemeProvider
      theme={{
        tintColor: color,
      }}
    >
      {children}
    </ThemeProvider>
  );
  return Theme;
}
